<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page standard_reg whiteandround">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help" v-if="!hasHE">
            <div class="row inner_logo">
              <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo.svg'" alt="">
            </div>
            <span>{{ getTranslations.visitor_sign_up_1_single_country_activate_free_trial }}</span>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasHE && !hasStepsToDisplay">
              <div class="StandardRegSteps_step">1</div>
              <div class="StandardRegSteps_step inactive">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
            <div class="twoStepRegSteps_Container" v-else>
              <div class="twoStepRegSteps_step">1</div>
              <div class="twoStepRegSteps_step inactive">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help">

              <div class="operators_selection_wrap" v-if="multiOperatorInfo.multiOperatorEnabled  && showOperators()">
                <p>{{ getTranslations.visitor_sign_up_1_single_country_my_operator }} </p>
                <div class="operators_radio">
                  <label v-for="(operator, index) in multiOperatorInfo.multiOperatorKeys"
                         class="operators_radio operators_radio_inline" :key="index"
                         v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[index]">
                    <img class="operators_icon" :src="getOperatorImage(index)" :alt="getOperatorDisplayName(index)">
                    <input type="radio" name="operator" :value="operator" v-model="operatorPicked"
                           @click="check();getOrdinalByOperator(operator);">
                    <span></span>
                  </label>
                </div>
                <div class="operators_error_msg" v-if="!operatorPicked && btnSubmitted"><span
                  class="form-group__feedback">{{ getTranslations.visitor_sign_up_1_single_country_select_operator
                  }}</span></div>
              </div>
              <div v-else-if="isBrandedProject && !brandedProjectForEverySkin">
                <img class="operator_register_promo_logo" :src="operatorLogoForBrandedProject">
              </div>
              <div v-else>
                <img class="form-help__icon" src="static/images/keypad-icon.svg" @error="imageErrorHandler" alt="">
              </div>

              <p>{{ getTranslations.visitor_sign_up_1_single_country_info_msg_enter_msisdn }}</p>
            </div>

            <form action="">
              <div class="form-group"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield phone_input"
                       id="msisdnInputField"
                       :readOnly="!!hasHE"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_1_single_country_placeholder"
                       @keyup="check" v-model="user.msisdn"/>
                <span v-show="getMessage(message) && user.msisdn" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>

              <div v-if="hasHE" class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <a
                  :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
                  target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
              </a>
              </div>


              <p v-if="showDisclaimerNotice() && !hasHE && !validationForOneTimeSubscription">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for') }}</p>

              <input v-if="!validationForOneTimeSubscription" type="submit"
                     :value="(!hasHE) ? getTranslations.visitor_sign_up_1_single_country_submit_button_continue : getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitAction">

              <input v-if="validationForOneTimeSubscription" type="submit" :value="getTranslations.visitor_sign_up_1_single_placeholder_daily_subscription"
                     :class="['one_time btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitActionForSubscriptionButtons(true)">
              <input v-if="validationForOneTimeSubscription" type="submit"
                     :value="getTranslations.visitor_sign_up_1_single_placeholder_one_time_subscription"
                     :class="['one_time btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitActionForSubscriptionButtons(false)">

              <p>
                {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
              </p>
              <ul v-if="hasSimplify()"
                class="alter_flow_list form-group__feedback reg_notice">
                <li v-for="(key, index) in disclaimers"
                    v-if="getTranslations[key]"
                    :key="index">
                  {{ getTranslations[key] }}
                </li>
              </ul>
              <div class="form-footer-text" v-if="showDisclaimer()">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer') }}
              </div>
              <div class="form-footer" v-if="validationForOneTimeSubscription">
                <p>{{ getTranslations.visitor_sign_up_1_single_country_for_daily_sub }}</p>
                <p>{{ getTranslations.visitor_sign_up_1_single_country_for_one_time }}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <confirmation v-if="showConfirmationModal"
                  @confirm="showConfirmationModal = false;getNextVerificationStep()();"
                  @close="showConfirmationModal = false;">
    </confirmation>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import FlowMixin from '@/common/mixins/flow';
import confirmation from '@/components/home/modals/Confirm';

export default {
  name: 'sign-up-1-single-country',
  components: { confirmation },
  mixins: [IntegrationMixin, FlowMixin],
  data() {
    return {
      operatorLogoForBrandedProject: '',
      btnSubmitted: false,
      operatorPicked: '',
      user: {
        msisdn: '',
        hash: '',
      },
      message: '',
      hasErrors: false,
      defaultImagePath: '/ext/banners/RegistrationDefault.png',
      imageUsed: '',
      waitForResponse: false,
      showConfirmationModal: false,
      validationForOneTimeSubscription: null,
      brandedProjectForEverySkin: null,
      hasStepsToDisplay: false,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3'],
    };
  },
  created() {
    if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && !this.multiOperatorInfo.multiOperatorEnabled && !document.getElementById('tpay_evina_script')) {
      const locale = this.getLocale;
      let lang;
      if (locale === 'EN') {
        lang = 'en';
      } else {
        lang = locale === 'AR' ? 'ar' : 'fr';
      }
      this.$axios.get(`publicapi/loadTpayScript?lang=${lang}`).then((params) => {
        /* eslint-disable */
        let date = params.data.data.date;
        let digest = params.data.data.digest;
        let liveOrStgUrl = params.data.data.liveOrStgUrl;
        sessionStorage.setItem("redirectUrl", params.data.data.redirectUrl);
        sessionStorage.setItem("can", params.data.data.customerAccountNumber);
        const url = `${liveOrStgUrl}?date=${date}&lang=${lang}&digest=${digest}`;
        $.get(url, function (script) {
          console.log(script);
          const scriptToAdd = document.createElement('script'); // Create <script>
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'tpay_evina_script';
          const code = document.createTextNode(script); // Attach TPay JS script to <script>
          scriptToAdd.appendChild(code);
          document.head.appendChild(scriptToAdd);
          const tag = document.createElement('script');
          tag.type = 'text/javascript';
          tag.id = 'tpay_evina_exe';
          let inlineScript = document.createTextNode("var event = new Event('Call');\n" +
            "document.dispatchEvent(event);\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode('document.dispatchEvent(event);');
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      });
      /* eslint-enable */
    }
    this.hasStepsToDisplay = this.hasSteps();
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.operatorPicked = operator;
    }
    if (this.$route.query.errorMessage) this.message = this.getTranslatedErrorMessage(this.$route.query.errorMessage);
    if (this.message) {
      this.user.msisdn = this.$route.query.errorMsisdn || '';
      this.hasErrors = true;
    } else if (this.getIntegrationByName()) {
      this.user.msisdn = this.$route.query.heMsisdn || '';
      this.user.hash = this.$route.query.heHash || '';
      this.setCorrelationId({ value: this.$route.query.cid || '' });
      this.$nextTick(() => {
        this.hasHE = this.user.msisdn && this.user.hash && this.isSingleOptIn();
      });
    }
    this.imageUsed = this.banner ? `/ext/banners/${this.banner}.jpg` : this.defaultImagePath;
    this.operatorLogoForBrandedProject = this.isBrandedProject ? this.determineImagePath() : '';
    this.validationForOneTimeSubscription = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.oneTimeSubscription;
    this.brandedProjectForEverySkin = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.isBrandedProjectEverySkin;
  },
  mounted() {
    /* eslint-disable */
    if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && document.getElementById('tpay_evina_script')) {
      console.log('TPay init with WE operator code');
      TPay.HeaderEnrichment.init({operatorCode: '60204'});
    }
    /* eslint-enable */
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'setDefaultDailySubButtonEnabled',
      'updateMultiOperatorOrdinal',
      'setCorrelationId',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    async prepareConfirm() {
      /* eslint-disable */
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        let msisdnInput = this.user.msisdn;
        console.log('MSISDN ', this.user.msisdn);

        if (this.user.msisdn.startsWith('01')) { // Transformation from 01 to 201
          msisdnInput = '2' + msisdnInput;
        }

        console.log('Transformed msisdn: ', msisdnInput);

        if (this.user.msisdn.length > 5) { // msisdn field gets filled up
          let obj = {
            msisdn: msisdnInput,
            subscriptionPlanId: '2300',
            productCatalog: 'The treasure',
            productSku: 'The treasure',
            operatorCode: '60204',
            customerAccountNumber: sessionStorage.getItem('can'),
          };

          console.log('Confirm return obj = ', obj);

          try {
            TPay.HeaderEnrichment.confirm(obj,
              async function (status, refCode, contract) {
                console.log('status: ' + status + ' refcode: ' + refCode + ' contract: ' + contract);

                if (status === true) { // No error or fail case
                  sessionStorage.setItem('status', status);
                  sessionStorage.setItem('refcode', refCode);
                  sessionStorage.setItem('contract', contract);

                  // Wifi flow
                  const sessionToken = await TPay.HeaderEnrichment.sessionToken();
                  console.log('Got sessionToken: ', sessionToken);
                }
              }
            );

          } catch (error) {
            console.error(error);
            return false;
          }
          const sessionToken = await TPay.HeaderEnrichment.sessionToken();
          sessionStorage.setItem('sessionToken', sessionToken);
        }
      }
      return true;
      /* eslint-enable */
    },
    onSubmitActionForSubscriptionButtons(isDailySubscription) {
      this.setDefaultDailySubButtonEnabled(isDailySubscription);
      this.btnSubmitted = true;
      this.checkButton(isDailySubscription);
    },
    showOperators() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.affectsMultiOperator;
    },
    showDisclaimerNotice() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getTranslatedErrorMessage(errorMessage) {
      switch (errorMessage) {
      case 'MSISDN_INVALID': return 'visitor_sign_up_invalid_msisdn_msg';
      case 'ALREADY_REGISTERED': return 'visitor_sign_up_msisdn_already_registered';
      case 'MSISDN_NOT_EXIST': return 'visitor_sign_up_msisdn_not_exists';
      case 'MSISDN_BLACKLISTED': return 'visitor_sign_up_msisdn_blacklisted';
      case 'BLOCKED_USER': return 'visitor_forgot_password_warning_msd_max_attempts';
      case 'CAMPAIGN_CLOSED': return 'visitor_sign_up_campaign_closed';
      case 'SERVER_ERROR': return 'home_profile_profile_edit_server_unvailable';
      default: return 'visitor_sign_up_warning_third_party_error';
      }
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    imageErrorHandler() {
      this.imageUsed = this.defaultImagePath;
    },
    check() {
      const validMsisdnRegex = /^[0-9]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    mapErrorMessages(resMessage) {
      if (resMessage === 'MSISDN_INVALID') {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        this.message = 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        this.message = 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        this.message = 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'CAMPAIGN_CLOSED') {
        this.message = 'visitor_sign_up_campaign_closed';
      } else if (resMessage === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      }
    },
    onSubmitAction() {
      this.btnSubmitted = true;
      if (!this.multiOperatorInfo.multiOperatorEnabled || (this.multiOperatorInfo.multiOperatorEnabled && this.operatorPicked)) {
        this.goToCheckButton();
      } else {
        this.hasErrors = true;
      }
    },
    async goToCheckButton() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && !this.multiOperatorInfo.multiOperatorEnabled) {
        const nextStepCall = await this.prepareConfirm();
        sessionStorage.setItem('operator', 'WE_EGY');
        console.log('NEXT STEP CALL: ', nextStepCall);
        if (nextStepCall) {
          this.checkButton();
        }
      } else {
        this.checkButton();
      }
    },
    checkButton(isDailySubscription) {
      const activeIntegration = this.getIntegrationByName();
      if (activeIntegration && activeIntegration.value.hasConfirmation && this.isSingleOptIn()) {
        this.showConfirmationModal = true;
      } else {
        let appropriateRequestPinStep = this.getAlternateRequestPinAction(isDailySubscription); // integration specific
        if (!appropriateRequestPinStep) {
          appropriateRequestPinStep = this.getNextVerificationStep()(); // flow specific (default)
        }
        appropriateRequestPinStep.call(this);
      }
    },
    determineImagePath() {
      let path = '';
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        path = 'static/images/operators/we-logo.png';
      } else {
        path = `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator.svg`;
      }
      return path;
    },
  },
  computed: {
    ...mapState('common', [
      'defaultDailySubButtonEnabled',
      'duelSkin',
      'banner',
      'isBrandedProject',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp1SingleCountry.vue